import React from 'react'
import Pdf from '../../pdf/Pdf'

function Q31() {
  return (
        <Pdf src={'1dt6Ei6RQ-iEYkMABUTKF-P1_GHKz9o-9'} title={'المقالة pdf'}/>
  )
}

export default Q31